<template>
  <div class="processing-wrapper flex-1">
    <div class="animation w-2/3 mx-auto -mt-20" ref="loadingAnimation"></div>
    <h3 class="processing my-3" v-html="$t('mobileScan.data_processing')"></h3>
    <p class="comeback my-3" v-html="$t('mobileScan.comeback_later')"></p>
  </div>
</template>

<script>
import lottie from 'lottie-web';
import loading from '@/assets/animations/loading.json';

export default {
  name: 'ScanProcessing',
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.loadingAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: loading,
    });
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.processing {
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  text-align: center;
  color: #262626;
}
.comeback {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #262626;
  opacity: 0.5;
}
</style>
